// ─── Global: Header Height ───────────────────────────────────────────────────
function getLayoutHeights() {
  const elements = [
    {
      selector: "[data-section-id='index-header']",
      variable: "--header-height",
    },
    {
      selector: ".announcement-bar",
      variable: "--announcement-bar-height",
    },
  ];
  elements.forEach(({ selector, variable }) => {
    const el = document.querySelector(selector);
    if (el) {
      document.documentElement.style.setProperty(
        variable,
        `${el.offsetHeight}px`,
      );
    }
  });
}

function setupShopifyDesignMode() {
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.querySelector("[data-section-id='index-header']")) {
        getHeaderHeight();
      }
    });
    document.addEventListener("shopify:section:reorder", () => {
      getHeaderHeight();
    });
  }
}
// ─── PriceFilter ─────────────────────────────────────────────────────────────
class PriceFilter {
  constructor() {
    this.interval = setInterval(() => {
      this._getElements();
      const { priceSlider, maxInput, minInput } = this;
      if (priceSlider && priceSlider.noUiSlider && maxInput && minInput) {
        this._setFilter();
        this._bindEvents();
        clearInterval(this.interval);
      }
    }, 100);
  }
  _getElements() {
    this.priceSlider = document.querySelector(
      ".boost-pfs-filter-option-price .boost-pfs-filter-option-range-slider",
    );
    this.minInput = document.querySelector(
      ".boost-pfs-filter-option-price .boost-pfs-filter-option-range-amount-min",
    );
    this.maxInput = document.querySelector(
      ".boost-pfs-filter-option-price .boost-pfs-filter-option-range-amount-max",
    );
  }
  _setFilter() {
    const max = parseFloat(this.priceSlider.noUiSlider.get()[1]);
    const minValue = 0; // Floor is always $0
    this.priceSlider.noUiSlider.updateOptions({
      range: { min: minValue, max },
    });
    this.priceSlider.noUiSlider.set([minValue, max]);
    this.minInput.value = minValue;
  }
  _bindEvents() {
    this.priceSlider.noUiSlider.on("update", (values) => {
      const [min, max] = values.map(Number);
      console.log("Min:", min, "Max:", max);
      this.minInput.value = min;
      this.maxInput.value = max;
    });
  }
}

// ─── LookBook ────────────────────────────────────────────────────────────────
class LookBook {
  constructor() {
    this._init();
  }
  _setInitialStates() {
    const imgs = [
      ...document.querySelectorAll(
        ".stacked-images__item .stacked-images__image img",
      ),
    ].filter(
      (img) =>
        getComputedStyle(img.closest(".stacked-images__image")).display !==
        "none",
    );
    const textEls = [
      ...document.querySelectorAll(
        ".stacked-images__item .float-heading, .stacked-images__item .float-subheading",
      ),
    ];
    gsap.set(imgs, { yPercent: -20 });
    gsap.set(textEls, { opacity: 0, x: -10 });
  }
  _init() {
    if (!document.body.classList.contains("page--lookbook")) return;
    this._setInitialStates();
    this._createLenis();
    this._renderLenis();
    this._initImageParallax();
    this._initSwiper();
  }
  _initSwiper() {
    this.lookbookSwiper = new Swiper(".lookbook--swiper", {
      slidesPerView: 1,
      centeredSlides: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });
    this.lookbookCollectionSwiper = new Swiper(".lookbook-collection--swiper", {
      slidesPerView: 1,
      spaceBetween: 40,
      centeredSlides: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });
  }
  _createLenis() {
    this.lenis = new Lenis({
      lerp: 0.05,
      easing: (t) => 1 - Math.pow(1 - t, 5),
    });
  }
  _renderLenis(time) {
    this.lenis.raf(time);
    requestAnimationFrame(this._renderLenis.bind(this));
  }
  _initImageParallax() {
    const sections = [...document.querySelectorAll(".stacked-images__item")];
    if (!sections.length) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      sections.forEach((el) => {
        const imgWrappers = el.querySelectorAll(".stacked-images__image");
        const heading = el.querySelector(".float-heading");
        const subheading = el.querySelector(".float-subheading");
        if (!imgWrappers.length) return;
        imgWrappers.forEach((imgWrapper) => {
          const img = imgWrapper.querySelector("img");
          if (!img) return;
          if (getComputedStyle(imgWrapper).display === "none") return;
          gsap.to(img, {
            yPercent: 20,
            ease: "none",
            scrollTrigger: {
              trigger: imgWrapper,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
            },
          });
        });
        const textEls = [heading, subheading].filter(Boolean);
        if (textEls.length) {
          const tl = gsap.timeline({
            defaults: {
              opacity: 1,
              x: 0,
              duration: 0.8,
              ease: "power3.out",
            },
            scrollTrigger: {
              trigger: el,
              start: "top 30%",
              toggleActions: "play none none reverse",
            },
          });
          tl.to(heading, {}).to(subheading, {}, "<0.1");
        }
      });
    });
  }
}
// ─── Init ─────────────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", () => {
  getLayoutHeights();
  setupShopifyDesignMode();
  new PriceFilter();
  new LookBook();
});
